import { MutationTree } from "vuex";
import {
  EMatchingSearchMutations,
  IMatchingSearchState,
} from "./matching-search.types";
import { generateBaseMutationsFor } from "@/services/store/utils/base-generators";
import { getBaseName } from "@/services/store/utils/get-base-name";

export const mutations: MutationTree<IMatchingSearchState> = {
  ...generateBaseMutationsFor<IMatchingSearchState, IMatchingSearchState>(
    "matchingSearch",
  ),

  [getBaseName(EMatchingSearchMutations.SET_FACETS)](state, facets) {
    state.facets = facets;
  },

  [getBaseName(EMatchingSearchMutations.SET_RESULTS)](state, results) {
    if (results.action === "search") {
      state.results = results.documents;
    } else {
      state.results = [...state.results, ...results.documents];
    }
    state.hit_count = results.found;
    state.page = results.page;
    state.per_page = results.per_page;
  },

  [getBaseName(EMatchingSearchMutations.SET_FILTERS)](state, filters) {
    state.filters = filters;
  },
};
